import { css } from 'styled-components';

export const styledTable = css`
  .ant-table table {
    font-size: 14px;
  }

  .ant-table-tbody > tr > td {
    height: 2px;
    padding: 6px;
  }
  .ant-table-thead > tr > th {
    height: 4px;
    padding: 6px;
  }
  .ant-table-cell {
    height: 4px;
    padding: 6px;
  }

  /* 
  .ant-table-thead > tr > th {
    height: 5px;
    padding: 4px;
  }
  .ant-table-tbody > tr > td {
    height: 5px;
    padding: 4px;
  }
  */

  /* .ant-table-tbody > tr:hover > td {
    height: 5px;
    padding: 4px;
    cursor: pointer;
    background-color: #dcdcdc;
  } */

  .edit-table-list-item {
  }

  .delete-table-list-item {
    color: #ff5349;
  }

  .download-table-list-item {
  }
`;

export const styledSOVTable = css`
  /* .ant-table table {
    font-size: 15px;
  }
  .ant-table-thead > tr > th {
    height: 5px;
    padding: 4px;
  }
  .ant-table-tbody > tr > td {
    height: 5px;
    padding: 4px;
  }
  .ant-table-tbody > tr:hover > td {
    height: 5px;
    padding: 4px;
  } */
`;

export const styledEditableTable = css`
  /* .ant-table table {
    font-size: 15px;
  }
  .ant-table-thead > tr > th {
    height: 5px;
    padding: 4px;
  }
  .ant-table-tbody > tr > td {
    height: 5px;
    padding: 4px;
  }
  .ant-table-tbody > tr:hover > td {
    height: 5px;
    padding: 4px;
  } */

  /* .editable-row .ant-form-item-explain {
    position: absolute;
    top: 100%;
    font-size: 19px;
  } */
`;

export const styledDescriptions = css`
  .ant-descriptions-title {
    font-size: 16px;
    font-weight: normal;
  }
  th.ant-descriptions-item-label {
    background-color: #e8e8e8;
  }
  /* 
  th.ant-descriptions-item-label {
    background-color: #e8e8e8;
    padding: 8px 12px;
  }
  td.ant-descriptions-item-content {
    padding: 8px 12px;
  } */
`;
